import React from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { Provider } from 'react-redux';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';
import store from './store';
import ScrollToTop from './ScrollToTop';
import Loading from '../../shared/Loading';
import 'bootstrap/dist/css/bootstrap.css';
import '../../scss/app.scss';
import { ToastContainer } from 'react-toastify';

const queryClient = new QueryClient({});

function App() {
  return (
    <QueryClientProvider client={queryClient} contextSharing={true}>
      <Provider store={store}>
        <RecoilRoot>
          <BrowserRouter>
            <ScrollToTop>
              <Loading />
              <Router />
              <ToastContainer />
            </ScrollToTop>
          </BrowserRouter>
        </RecoilRoot>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
